// brandVendorOrdersActions.js
import * as api from "../api";
import {
  BRAND_VENDOR_ORDERS_REQUEST,
  BRAND_VENDOR_ORDERS_SUCCESS,
  BRAND_VENDOR_ORDERS_FAIL,
} from "../constants/webOrderConstants";

// `filters.outletId` narrows the page to orders fulfilled from one brand
// outlet; left out, the list is every order for the vendor as before.
export const fetchBrandVendorOrders =
  (vendorId, page = 1, limit = 10, filters = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: BRAND_VENDOR_ORDERS_REQUEST });

      const { data } = await api.fetchBrandVendorOrdersApi(
        vendorId,
        page,
        limit,
        filters
      );

      dispatch({
        type: BRAND_VENDOR_ORDERS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: BRAND_VENDOR_ORDERS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

